import { ObservableFromFetch } from "../ObservableFromFetch"
import LabAccount from "./Model/LabAccount"

export default function LabAccountListGet(implementationID: number, accountID: number, isLocation: boolean) {
  const requestBody: string = new URLSearchParams({
    implementationID: implementationID.toString(),
    accountID: accountID.toString(),
    isLocation: isLocation.toString()
  }).toString()

  return ObservableFromFetch<{ActiveLabAccount: LabAccount[], InActiveLabAccount: LabAccount[]}>("FFOrderLaboratory/GetLabAccount?" + requestBody)
}